import React from "react";
import CheckboxField from "../../../../../../components/form-fields/checkbox-field/check-box";

const AddProjectsColumns = (selectedProjects, setSelectedProjects) => {
  return [
    {
      dataKey: "",
      name: "",
      width: "1%",
      align: "left",
      render: (cellData, rowData) => {
        const handleCheckBoxClick = () => {
          const isPresent = selectedProjects.includes(rowData.id);
          setSelectedProjects((prev) => {
            if (isPresent) {
              return prev.filter((x) => x !== rowData.id);
            }
            return [...prev, rowData.id];
          });
        };

        return (
          <CheckboxField
            value={selectedProjects.includes(rowData.id)}
            onChange={handleCheckBoxClick}
          />
        );
      },
    },
    {
      dataKey: "id",
      name: "ID",
      width: "1%",
      align: "left",
    },
    {
      dataKey: "projectName",
      name: "Name",
      width: "40%",
      align: "left",
    },
    {
      dataKey: "state",
      name: "State",
      width: "40%",
      align: "left",
    },
  ];
};

export default AddProjectsColumns;
